import React from 'react';
import UpdateBookmarkPage from '../updateUserProject';

const ApproveUserProjectPage = () => <UpdateBookmarkPage status='accepted' />;

export default ApproveUserProjectPage;
